import React, { useEffect, useContext } from "react";

import SocketService from "../service/socket";
import { SocketStateContext } from "../provider";

export default () => {
  const [socketInfo, setSocketInfo] = useContext(SocketStateContext);

  const addChat = ({ username, msg, roomId }) => {
    const newSocketInfo = socketInfo;
    if (!newSocketInfo[roomId]) newSocketInfo[roomId] = { chats: [] };
    newSocketInfo[roomId]["chats"].push({ username, msg });
    setSocketInfo({ ...socketInfo, ...newSocketInfo });
  };

  const stateManager = (newSocketInfo) => {
    setSocketInfo({ ...socketInfo, ...newSocketInfo });
  };

  useEffect(() => {
    SocketService.register([stateManager, addChat]);
  }, [socketInfo]);

  return <></>;
};
